import { useMemo } from "react"

import { merge } from "lodash"
import { useParams } from "react-router-dom"

import { DOCUMENT_ATTACHED_ITEM_LAYER, DOCUMENT_ITEMS_LAYER, getInterpolatedLineLayerWidth, getLineLayerConfig, Layer, MapStyles, SELECTED_LINE_LAYER_SIZE, useMapStateContext, useOrderingLayers } from "@l2r-front/l2r-map"
import { useTheme } from "@l2r-front/l2r-ui"
import { selectLayerColorOpacity, useUrlParams } from "@l2r-front/l2r-utils"

import { LINEAR_LOCATION_END, LINEAR_LOCATION_START } from "../../constants/urlParams"

import { DocumentAttachedObjectSource } from "../DocumentAttachedObjectSource"

export function DocumentAttachedObjectLayer() {

    const { getCurrentMapStyle } = useMapStateContext()
    const theme = useTheme()
    useOrderingLayers(["road-number", "road-number-shield", DOCUMENT_ITEMS_LAYER, DOCUMENT_ATTACHED_ITEM_LAYER])
    const { road } = useParams()
    const { getParam } = useUrlParams()
    const documentAttachedObjectLayerConfig = useMemo(() => {
        const lineColor = getCurrentMapStyle() === MapStyles.plan ? selectLayerColorOpacity(theme.palette.map.darkReferential, 0.5, road, null, getParam(LINEAR_LOCATION_START), getParam(LINEAR_LOCATION_END)) : selectLayerColorOpacity(theme.palette.map.lightReferential, 0.85, road, null, getParam(LINEAR_LOCATION_START), getParam(LINEAR_LOCATION_END))
        return merge(
            getLineLayerConfig({
                paint: {
                    "line-color": lineColor,
                    "line-width": getInterpolatedLineLayerWidth(SELECTED_LINE_LAYER_SIZE),
                },
            }),
        )
    }, [getCurrentMapStyle, getParam, road, theme.palette.map.darkReferential, theme.palette.map.lightReferential])

    return <DocumentAttachedObjectSource id="document-attached-object-source">
        <Layer
            {...documentAttachedObjectLayerConfig}
            id={DOCUMENT_ATTACHED_ITEM_LAYER}
        />
    </DocumentAttachedObjectSource>
}